import { Injectable } from '@angular/core';
import { EnvironmentService } from '../environment-service/environment.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AgentCapabilityService {

  constructor(
    private http: HttpClient, 
    private environmentService: EnvironmentService
  ) { }

  getCapabilities(): any {
    const url = this.environmentService.getApiRoot() + `vsts/agent-capabilities`;
    return this.http.get(url);
  }
}
